import { useInfiniteQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/client";
import { ENDPOINTS } from "@/api/endpoints";
import { InsightByDate } from "@/types/insights.types";
import { PaginatedResponse } from "@/types/common.types";

type InsightByDateResponse = PaginatedResponse<InsightByDate>;

interface GetInsightsByDateParams {
  jobId: string;
  date: string;
  page?: number;
  size?: number;
}

const getInsightsForJobByDate = async ({
  jobId,
  date,
  pageParam = 0,
}: GetInsightsByDateParams & {
  pageParam?: number;
}): Promise<InsightByDateResponse> => {
  return apiClient
    .get(ENDPOINTS.GET_INSIGHTS_FOR_JOB_BY_DATE(jobId, date, pageParam))
    .json<InsightByDateResponse>();
};

export const useGetInsightsForJobByDateQuery = (
  params: Omit<GetInsightsByDateParams, "page">,
  size: number = 50
) => {
  return useInfiniteQuery({
    queryKey: ["jobInsightsByDate", params.jobId, params.date, size] as const,
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      getInsightsForJobByDate({
        ...params,
        pageParam: pageParam as number,
        size,
      }),
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages - 1) {
        return undefined;
      }
      return lastPage.page + 1;
    },
    gcTime: Infinity,
    staleTime: Infinity,
  });
};
